export const tr = {
    archive: 'Arşivlenen',
    creatives: 'Kreatiflerim',
    upload: 'Yükle'
};
